module.exports = __webpack_public_path__ + "img/eat.b87fa63e.svg";